<template>
  <section class="grid-flex column">
    <div>
      <h3>Editar Funil</h3>
    </div>
    <section class="box flex-1 w100 margin-top-s">
      <div class="box-content">
        <div class="item ">
          <label>Nome:</label>
          <input class="input margin-top-s" v-model="newFunnel.name">
        </div>
      </div>
    </section>
    <div class="margin-top-l">
      <h3>Etapas do Funil</h3>
    </div>
    <section class="box flex column w100 margin-top-s">

      <div class="box-content list-itens flex column w100">
        <div> 
          <div class="button primary" @click="openModalCreate()">
            Criar nova Etapa
          </div>
        </div>
        <div
          class="box flex-1 w100 step-item"
          v-for="(fs, index) in funnelSteps"
          :key="index"
        >
        <div class="box-content">
          <div class="flex-1 w100">
            <div class="flex middle row">
              <div class="flex-3">
                <div class="flex middle row">
                  <div class="flex-1 name">
                    <div>
                      Nome: {{ fs.name }}
                    </div>
                    <div class="margin-top-s">
                      Regra(s): {{ fs.rule_fields && fs.rule_fields.length | number }}
                    </div>
                  </div>
                  
                </div>
              </div>
              <div class="action">
                <div class="flex end">
                  <div class="button primary" @click="openToEdit(fs)">
                    EDITAR
                  </div>
                  <div
                    class="button primary"
                    @click="openToDelete(fs.id)"
                    style="margin-left: 8px"
                  >
                    DELETAR
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
      <div v-if="isEmpty" class="box flex w100">
        <div class="box-content">
          <p>
            Não encontramos nenhum etapa do funil criado. Crie seu primeiro etapa do funil para ter
            seus rastreamentos.
          </p>
        </div>
      </div>

      <div v-if="loading" class="flex w100">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>
    </section>

    <section class="flex w100 margin-top-l">
      <div class="button secondary" style="margin-right: 8px;" @click="$router.back()">Voltar</div>
      <div class="button primary"  @click="updateFunnel()">Salvar</div>
    </section>

    <!-- modal create / edit -->
    <modal
      :title="titleModal"
      :show="showModalCreateOrUpdate"
      largebox="true"
      @close="closeToEdit()"
    >
      <div class="content flex " slot="content">
        <div class="flex column w100">
          <form autocomplete="off" class="w100">
            <div class="flex-1 w100">
              <label>Nome</label>
              <input
                class="input"
                id="name"
                type="text"
                v-model="newFunnelStep.name"
                autocomplete="off"
              />
            </div>
            <div class="flex-1 w100 margin-top-s">
              <label>Order</label>
              <input
                class="input"
                id="order"
                type="number"
                v-model="newFunnelStep.order"
                autocomplete="off"
              />
            </div>
            <div class="flex-1 w100 margin-top-s">
              Regras de público
              <div>
                <div class="button primary" @click="addNewRule()"> Adicionar Regra </div>
              </div>
              <div class="margin-top-s" v-for="(newActive, key) in this.newActives" :key="`${key}-action`">
                <div v-if="key >= 1">OU</div>
                <form class="w100 border-action" :key="`${newActive.id}-form`">
                  <div class="flex end">
                    <div @click="removeNewRule(key)" class="button secondary small">Remover</div>
                  </div>
                    <div class="flex-1">
                      <div class="margin-top-s flex-1">
                        <label>Tipo de Acionador:</label>
                        <select class="input" v-model="newActive.type_action" :key="newActive.type_action">
                          <option value="">Seleciona</option>
                          <option
                            v-for="(f, index) in listActives"
                            :key="index"
                            :value="f.value"
                            :selected="f.value === newActive.type_action"
                          >
                            {{ f.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="flex-1 w100 margin-top-s">
                      <div class="margin-top-s">
                        <div v-if="newActive.type_action == 'PAGEVIEW'" class="flex column">
                          <div class="flex w100 column margin-top-s">
                            <label>Campo</label>
                            <select class="input" v-model="newActive.custom_fields.field">
                              <option value="">Seleciona</option>
                              <option
                                v-for="(f, index) in listValuesUrl"
                                :key="index"
                                :value="f.value"
                                :selected="f.value === newActive.custom_fields.field"
                              >
                                {{ f.name }}
                              </option>
                            </select>
                          </div>
                          <div class="flex w100 column margin-top-s">
                            <label>Operador</label>
                            <select class="input" v-model="newActive.custom_fields.operator">
                              <option value="">Seleciona</option>
                              <option
                                v-for="(f, index) in listOperators"
                                :key="index"
                                :value="f.value"
                                :selected="f.value === newActive.custom_fields.operator"
                              >
                                {{ f.name }}
                              </option>
                            </select>
                          </div>
                          <div class="flex w100 column margin-top-s">
                            <label>Valor</label>
                            <input
                              class="input margin-top-s"
                              v-model="newActive.custom_fields.value"
                            />
                          </div>
                        </div>
                        <div v-if="newActive.type_action == 'PAGEVIEW-TIME'" class="flex">
                            <div class="flex w100 column margin-top-s">
                            <label>Tempo</label>
                            <select class="input" v-model="newActive.custom_fields.value">
                              <option value="">Seleciona</option>
                              <option
                                v-for="(f, index) in listTimePageview"
                                :key="index"
                                :value="f.value"
                                :selected="f.value === newActive.custom_fields.value"
                              >
                                {{ f.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div v-if="newActive.type_action == 'SCROLL'" class="flex">
                          <div class="flex w100 column margin-top-s">
                            <label>Scroll</label>
                            <select class="input" v-model="newActive.custom_fields.value">
                              <option value="">Seleciona</option>
                              <option
                                v-for="(f, index) in listScrollPage"
                                :key="index"
                                :value="f.value"
                                :selected="f.value === newActive.custom_fields.value"
                              >
                                {{ f.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div v-if="newActive.type_action == 'LEAD'" class="flex">
                          <p>Todos leads serão considerados</p>
                        </div>
                        <div v-if="newActive.type_action == 'PURCHASE'" class="flex">
                          <div class="flex w100 column margin-top-s">
                            <label>Nome do Produto</label>
                            <input
                              class="input margin-top-s"
                              v-model="newActive.custom_fields.value"
                            />
                          </div>
                        </div>
                        <div v-if="newActive.type_action == 'CLICK'" class="flex">
                          <div class="flex w100 column margin-top-s">
                            <label>Adicionar classe ao elemento via HTML:</label>
                            <input
                              class="input margin-top-s"
                              v-model="newActive.custom_fields.value"
                            />
                          </div>
                        </div>
                        <div v-if="newActive.type_action == 'VIEW-CONTENT'" class="flex">
                          <div class="flex w100 column margin-top-s">
                            <label>Adicionar classe ao elemento via HTML:</label>
                            <input
                              class="input margin-top-s"
                              v-model="newActive.custom_fields.value"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
              </div>
            </div>
          </form>
          <div class="flex w100 center margin-top-l">
            <div class="button primary" @click="saveOrupdateFunnelStep()">
              {{isEdit ? 'SALVAR': 'CRIAR'}}
            </div>
          </div>
        </div>
      </div>
    </modal>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar essa Etapa do Funil?"
      @cancel="
        showModalDelete = false;
        selectedStepId = null;
      "
      @accept="deleteFunnelStep(selectedStepId)"
    ></modal-confirm>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";
import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";

import {
  getFunnel,
  updateFunnel,
  deleteFunnel,
  getFunnelSteps,
  createFunnelStep,
  updateFunnelStep,
  deleteFunnelStep,
  createFunnelStepAction,
  updateFunnelStepAction,
  getFunnelStepActions,
  deleteFunnelStepAction
} from "@/services/funnel";

const EMPTY_FUNNEL_STEP = {
  name: "",
  order : 1,
  rule_fields: []
};

const EMPTY_ACTIVE = {
  type_action: "",
  custom_fields: {}
};


export default {
  name: "funnel",
  components: {
    Modal,
    ModalConfirm,
  },
  props: ['funnel_id'],
  data() {
    return {
      loading: false,
      loadingReport: false,
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      selectedStepId: null,
      newFunnelStep: Object.assign({}, EMPTY_FUNNEL_STEP),
      funnelSteps: [],
      newFunnel: {},
      newActives: [],
      listActives: [
        { name: "Visita em Página", value: "PAGEVIEW" },
        { name: "Lead", value: "LEAD" },
        { name: "Conversa Iniciada", value: "CONVERSATION" },
        { name: "Compra", value: "PURCHASE" },
        // FIXME: PRECISO TER OS EVENTS NO PAINEL PARA ISSO...
        // ESSA PARTE NÃO É FEITA
        // { name: "Tempo de Visita em Página", value: "PAGEVIEW-TIME" },
        // { name: "Scroll de página", value: "SCROLL" },
        // { name: "Clique em Botão", value: "CLICK" },
        // { name: "Visualização de elementos", value: "VIEW-CONTENT" },
        // { name: "Player de Vídeo", value: "PLAY" },
        // { name: "Tempo de Player em Vídeo", value: "PLAY-TIME" },
        // { name: "Chamada em URL", value: "URL-GET" },
      ],
      // FIXME: DEIXAR CRIAR FUNIL PELOS EVENTOS PADRÕES DA META.
      listEventsFaceBook: [
        { name: "Click", value: "Click" },
        { name: "PageView", value: "PageView" },
        { name: "ViewContent", value: "ViewContent" },
        { name: "AddToCart", value: "AddToCart" },
        { name: "InitiateCheckout", value: "InitiateCheckout" },
        { name: "AddPaymentInfo", value: "AddPaymentInfo" },
        { name: "Purchase", value: "Purchase" },
        { name: "Register", value: "Register" },
        { name: "Subscribe", value: "Subscribe" },
      ],
      listOperators: [
          { name: "Contém", value: "content" },
          { name: "Não Contém", value: "nocontent" },
      ],
      listValuesUrl: [
          { value: 'url', name: 'Url' },
          { value: 'utm_source', name: 'utm_source' },
          { value: 'utm_content', name: 'utm_content' },
          { value: 'utm_medium', name: 'utm_medium' },
          { value: 'utm_campaign', name: 'utm_campaign' },
          { value: 'utm_term', name: 'utm_term' },
          { value: 'src', name: 'src' },
          { value: 'sck', name: 'sck' },
      ],
      listTimePageview: [
          { value: '15S', name: '15 segundos' },
          { value: '30S', name: '30 segundos' },
          { value: '60S', name: '60 segundos' },
          { value: '120S', name: '120 segundos' },
      ],
      listScrollPage: [
          { value: '25', name: '25%' },
          { value: '50', name: '50%' },
          { value: '75', name: '75%' },
          { value: '100', name: '100%' },
      ],
    };
  },
  mounted() {
    this.getFunnel();
    this.getFunnelSteps();
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.funnelSteps = [];
        this.reportfunnelSteps = {};
        this.getFunnelSteps();
      },
    },
    page: {
      handler() {
        this.funnelSteps = [];
        this.getFunnelSteps();
      },
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    titleModal() {
      return this.isEdit ? 'Editar Etapa': 'Criar Etapa'
    },
    isEmpty() {
      return this.totalfunnelSteps === 0 && !this.loading;
    },
    isEdit() {
      if (this.newFunnelStep && this.newFunnelStep.id) {
        return true
      }
      return false
    },
    totalPages() {
      let valueMode = this.totalfunnelSteps % this.offset;
      let value = this.totalfunnelSteps / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
    alertLimit() {
      if (this.account && this.account.plan_limits.limit_shortlink <= this.account.used_limits.limit_shortlink) {
        return true
      }

      return false
    },
  },
  methods: {
    addNewRule() {
      this.newActives.push(this.$ObjectCopy(EMPTY_ACTIVE))
    },
    removeNewRule(index) {
      if (this.newActives && this.newActives.length === 1) {
        if (this.newActives[0].id) {
          this.deleteFunnelStepAction(this.funnel_id, this.newFunnelStep.id, this.newActives[0].id)
        }
        this.newActives = []
        return
      }

      this.deleteFunnelStepAction(this.funnel_id, this.newFunnelStep.id, this.newActives[index].id)
      this.newActives = this.newActives.splice(index, 1)
    },
    getClicks(shId) {
      if (!this.reportfunnelSteps[shId]) {
        return '-'
      }

      return this.reportfunnelSteps[shId][ 'clicks']
    },
    openModalCreate() {
      if(this.alertLimit) {
        this.$toast.error({
          title:'Erro',
          message:'Você já está usando o limite de links rastreaveis do seu plano! Faça upgrade para criar mais!'
        })

        return

      }
      
      this.showModalCreateOrUpdate = true
    },
    openToDelete(sl) {
      this.showModalDelete = true;
      this.selectedStepId = sl;
    },
    openToEdit(sl) {
      this.showModalCreateOrUpdate = true;
      this.newFunnelStep = sl;
      this.newActives = sl.actions
    },
    closeToEdit() {
      this.showModalCreateOrUpdate = false;
      this.newFunnelStep = Object.assign({}, EMPTY_FUNNEL_STEP);
      this.newActives = []
    },
    saveOrupdateFunnelStep() {
      if (this.isEdit) {
        this.updateFunnelStep(this.newFunnelStep.id);
      } else {
        this.createFunnelStep();
      }
      this.closeToEdit();
    },
    getFunnel() {
      this.loading = true;
      getFunnel(this.funnel_id)
        .then((result) => {
          this.newFunnel = result;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    updateFunnel() {
      let params = {
        name: this.newFunnel.name,
      };

      updateFunnel(this.funnel_id, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Funil editado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    deleteFunnel(funnelId) {
      deleteFunnel(funnelId)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Funil deletado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.selectedStepId = null;
          this.showModalDelete = false
        })
    },
    getFunnelSteps() {
      this.loading = true;
      getFunnelSteps(this.funnel_id)
        .then((result) => {
          this.funnelSteps = result.funnel_steps;


          this.funnelSteps.forEach(s => {
            this.getFunnelStepActions(this.funnel_id, s.id)
              .then(result => {
                s.actions = result.actives
              })
          })
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createFunnelStep() {
      let params = {
        name: this.newFunnelStep.name,
        order: this.newFunnelStep.order,
      };

      var _aux_actives = this.$ObjectCopy(this.newActives)
      createFunnelStep(this.funnel_id, params)
        .then((newStep) => {
          // cria todos os active do step
          var _promisses = []
          _aux_actives.forEach( a => {
            _promisses.push(this.updateOrCreateFunnelStepAction(this.funnel_id, newStep.id, a))
          })

          Promise.all(_promisses)
            .then(() => {
              this.$toast.success({
                title: "Sucesso",
                message: "Etapa criada com sucesso",
              });
              
              // atualiza novo objeto de step com actions
              this.getFunnelStepActions(this.funnel_id, newStep.id)
                .then(result => {
                  newStep.actions = result.actives
                })
                this.funnelSteps.push(newStep);
              })
        })
        .catch((e) => {
          console.log('e', e)
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    updateFunnelStep(stepId) {
      let params = {
        name: this.newFunnelStep.name,
        order: this.newFunnelStep.order,
      };
      
      var _promisses = []
      _promisses.push(updateFunnelStep(this.funnel_id, stepId, params))

      var _aux_actives = this.$ObjectCopy(this.newActives)
      _aux_actives.forEach( a => {
        _promisses.push(this.updateOrCreateFunnelStepAction(this.funnel_id, stepId, a))
      })

      Promise.all(_promisses)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Etapa editada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    updateOrCreateFunnelStepAction(funnelId, stepId, action) {
      if (action && action.id) {
        return this.updateFunnelStepAction(funnelId, stepId, action)
      } else {
        return this.createFunnelStepAction(funnelId, stepId, action)
      }
    },
    updateFunnelStepAction(funnelId, stepId, action) {
      var parans = {
        type_action: action.type_action,
        custom_fields: action.custom_fields,
      }
      return updateFunnelStepAction(funnelId, stepId, action.id, parans)
    },
    getFunnelStepActions(funnelId, stepId) {
      return getFunnelStepActions(funnelId, stepId)
    },
    createFunnelStepAction(funnelId, stepId, action) {
      var parans = {
        type_action: action.type_action,
        custom_fields: action.custom_fields,
      }
      return createFunnelStepAction(funnelId, stepId, parans)
    },
    deleteFunnelStep(setpId) {
      deleteFunnelStep(this.funnel_id, setpId)
        .then(() => {

          this.funnelSteps = this.funnelSteps.filter(e => e.id !== setpId)
          this.$toast.success({
            title: "Sucesso",
            message: "Etapa deletado com sucesso",
          });


        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.selectedStepId = null;
          this.showModalDelete = false
        })
    },
    deleteFunnelStepAction(funnelId, stepId, actionId) {
      deleteFunnelStepAction(funnelId, stepId, actionId)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Regras deletado com sucesso",
          });


        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
        })
    }
  },
};

</script>

<style lang="scss" scoped>

.list-itens {
  .box + .box {
    margin-top: 8px;
    margin-left: 0px !important;
  }
}

.name {
  max-width: 400px;
  width: 400px;
  min-width: 400px;
  padding-right: 16px;
}
.step-item {
  border-radius: 8px;
  border: 1px solid #c3c3c3;
  margin-top:8px;
}
.border-action {
  border: 1px solid #c2c2c2;
  border-radius: 4px;
  padding: 8px 14px;
}
</style>
